import { PageHeader, PageShell } from '@/components/PageShell';
import { HomeEvalJobsPage } from '@/app/jobs/HomeEvalJobsPage';
import { TaskGenerationJobsPage } from '@/app/jobs/TaskGenerationJobsPage';
import { TabNav } from '@/components/TabNav';
import type { FC } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

export const JobsPage: FC = () => {
    return (
        <PageShell>
            <PageHeader title="Jobs" description="View home evaluation and task generation job runs." />
            <TabNav
                tabs={[
                    { label: 'Home Eval', to: '/system/jobs/home-eval' },
                    { label: 'Task Generation', to: '/system/jobs/task-generation' },
                ]}
            />
            <Routes>
                <Route index element={<Navigate replace to="home-eval" />} />
                <Route path="home-eval/*" element={<HomeEvalJobsPage />} />
                <Route path="task-generation/*" element={<TaskGenerationJobsPage />} />
            </Routes>
        </PageShell>
    );
};
